import { createContext } from 'react';

export default createContext({
  optionLabelName: 'label',
  optionValueName: 'value',
});
